import React, { FC } from "react";
import { useSelector } from "react-redux";

import PageLayout from "../../layouts/PageLayout";
import SessionExpiredWarning from "./components/SessionExpiredWarning";
import WelcomeSection from "./components/WelcomeSection";
import { ReduxApplicationState } from "../../types/ReduxTypes/ReduxApplicationState";

const DashboardPage: FC = () => {
  const agency = useSelector((state: ReduxApplicationState) => state.agency);

  return !agency.agencyId ? (
    <PageLayout heading="">
      <SessionExpiredWarning />
    </PageLayout>
  ) : (
    <>
      <PageLayout
        heading="The only B2B advertising platform that scales from entry-level SMB to Enterprise."
        dashboardPage
      >
        <WelcomeSection />
      </PageLayout>
    </>
  );
};

export default DashboardPage;
